// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".article-paragraph a{font-weight:600;color:#3c3c3b;text-decoration:underline}", ""]);
// Exports
module.exports = exports;
